<app-page>
    <section class="col-12 md:col-10 lg:col-8 xl:col-5 m-auto mb-2 py-4 px-4 md:px-0">
        <p-card *ngIf="currentScenario">
            <div class="text-center">
                <i [ngClass]="currentScenario.icon" class="icon-large text-blue-200"></i>
                <p>
                    <strong class="text-slate-950 text-lg md:text-xl lg:text-2xl"
                        [innerHTML]="currentScenario.title"></strong>
                </p>
                 <div class="mx-auto line-height-3" style="max-width: 450px;">
                    <ng-container *ngFor="let item of currentScenario?.content; let i = index; trackBy: trackByIndex">
                        <p>
                            {{ item.text }}
                            <a  *ngIf="vivrSessionParam && item.loginLink" class="underline text-blue-700 cursor-pointer ml-1" (click)="navigateToLogin()">Login to My Account.</a>
                            <a  *ngIf="!vivrSessionParam && item.loginLink " class="underline text-blue-700 cursor-pointer ml-1" (click)="navigateToLogin()">My&nbsp;Account.</a>
                        </p>
                    </ng-container>
                </div>
            </div>
        </p-card>
    </section>
</app-page>